import Vue from 'vue';
import mixin from "../../../mixins/mixin";
import paymentService from './../../../services/payment';

export default {
  data() {
    return {
        success: this.$t('payments.success'),
        error: null,
        loading: false,
        permalink: this.$route.params.permalink,
        message: '',
        payment: {},
        status: this.$route.params.status,
        pageTitle: '',
        userCurrency: '€'
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue')
  },
  mixins:[mixin],
  async mounted() {
      let vm = this;
      vm.loading = true;
      await vm.fetch_payment(vm.permalink);
  },
  methods: {
      async fetch_payment(permalink){
          let vm = this;
          if(vm.status == 'success'){
              await paymentService.getByPermalinkWithStatus(vm, permalink, 'success');
          }else if(vm.status == 'error') {
              await paymentService.getByPermalinkWithStatus(vm, permalink, 'error');
          }else{
            alert("error");
          }
      }
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/payments/success/success.js